import { createContext, useContext, useState } from "react";

export const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        let language = localStorage.getItem("language")
        if (!language) {
            localStorage.setItem("language", "ru")
            language = localStorage.getItem("language")
        }
        return language
    })
    const toggleLanguage = (newValue) => {
        localStorage.setItem("language", newValue)
        setLanguage(newValue)
    }
    return (
        <LanguageContext.Provider value={[ language, toggleLanguage]}>
            {children}
        </LanguageContext.Provider>
    )
}

export default function useLanguage() {
    return useContext(LanguageContext)
}